import React from 'react'
import PropTypes from 'prop-types'

// material ui
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'

// components
import CloseIcon from 'uno/images/account/icon-close.svg'
import Typography from '@mui/material/Typography'

const ModalWrapper = props => {
  const {
    modal, // via redux state (currently selected modal)
    modalId, // via passed props (id of this modal)
    handleExit, // via container
    handleClose, // via container
    title, // via passed props
    closeButton, // via passed props
    children
  } = props

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={modal.open && modal.id === modalId}
      onClose={handleClose}
      TransitionProps={{
        onExit: handleExit
      }}
    >
      <>
        {closeButton && (
          <Box position='absolute' right='0px' top='0px'>
            <IconButton onClick={handleClose} size='small'>
              <CloseIcon width='3rem' />
            </IconButton>
          </Box>
        )}
        <Box m={[2, 4, 6]}>
          {title && (
            <Typography align='center' variant='h3' mb={[2, 4]} px={4}>
              {title}
            </Typography>
          )}

          {children}
        </Box>
      </>
    </Dialog>
  )
}

ModalWrapper.propTypes = {
  modal: PropTypes.object.isRequired,
  modalId: PropTypes.string,
  handleExit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  closeButton: PropTypes.bool
}

export default ModalWrapper
